<template>
  <video
    class="lazyload"
    preload="none"
    muted
    loop
    playsinline
    autoplay>
    <source :src="src" />
    Sorry, your browser doesn't support embedded videos.
  </video>
</template>

<script>
export default {
  name: 'VVideo',

  props: ['video'],

  computed: {
    src () {
      return this.video.src;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
